class ScrollToElement {
  static scrollToElement($element, offset = 0, options = {}) {
    if ($element) {
      const top = $element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top - offset,
        behavior: "smooth",
        ...options
      });
    }
  }

  static scrollToElementBySelector(selector, offset = 0) {
    const $element = document.querySelector(selector);
    this.scrollToElement($element, offset);
  }

  static scrollIntoViewBySelector(selector, offset = 0) {
    const $element = document.querySelector(selector);
    if ($element) {
      document.documentElement.style.scrollPaddingTop = `${offset}px`;
      $element.scrollIntoView({
        behavior: "smooth"
      });

      setTimeout(() => {
        document.documentElement.style.scrollPaddingTop = "auto";
      }, 500); // 500ms is the default scroll duration
    }
  }
}

export default ScrollToElement;
